export default "__VITE_ASSET__bb188ed9__"